<template>
    <div class="orgDetail">
        <div class="left-box">
            <LeftPage :active="2"/>
        </div>
        <div class="right-box  flex flex-direction">
            <div class="table-box flex-sub">
                <div class="title">
                    <div class="icon-box">
                        <i class="iconfont icon-tongzhi"></i>
                    </div>
                    <b>通知公告</b>
                </div>
                <div class="search-flex">
                    <div class="search-box">
                        <el-form ref="form" :model="search" class="flex" label-width="80px">
                            <el-form-item label="关键词">
                                <el-input v-model="search.keyword" placeholder="请输入关键词"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="search-btn" @click="refreshList">
                            <i class="iconfont icon-sousuo"></i>搜索
                        </div>
                        <div class="shensu margin-left-sm" @click="addItem(false)">
                            <i class="el-icon-plus"></i>添加通知公告
                        </div>
                    </div>

                </div>
                <div class="list ">
                    <el-table
                        :cell-style="textCenter"
                        :data="tableData"
                        :header-cell-style="centerbgc"
                        border
                        style="width: 100%" v-loading="loading">
                        <el-table-column
                            label="序号"
                            type="index"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            label="标题"
                            prop="title"
                            width="">
                        </el-table-column>
                        <el-table-column
                            label="时间"
                            prop="publish_time"
                            width="200">
                        </el-table-column>
                        <el-table-column label="排序" prop="name" width="150">
                            <template slot-scope="scope">
                                <div>
                                    <el-input-number v-model="scope.row.sort" :min="0" :precision="0" :controls="false" @change="(e)=>{ return changeStatus(e,1,scope.row)}" size="mini"></el-input-number>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" prop="is_show" width="120">
                            <template slot-scope="scope">
                                <div>
                                    <el-switch v-model="scope.row.status" :active-text="''" :active-value="1"
                                               :inactive-text="''" :inactive-value="0"
                                               @change="(e)=>{ return changeStatus(e,4,scope.row)}">
                                    </el-switch>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="置顶"
                            prop="is_top"
                            width="120">
                            <template slot-scope="scope">
                                <div>
                                    <el-switch v-model="scope.row.is_top" :active-text="''" :active-value="1"
                                               :inactive-text="''" :inactive-value="0"
                                               @change="(e)=>{ return changeStatus(e,2,scope.row)}">
                                    </el-switch>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="推荐"
                            prop="is_tui"
                            width="120">
                            <template slot-scope="scope">
                                <div>
                                    <el-switch v-model="scope.row.is_tui" :active-text="''" :active-value="1"
                                               :inactive-text="''" :inactive-value="0"
                                               @change="(e)=>{ return changeStatus(e,3,scope.row)}">
                                    </el-switch>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="180">
                            <template slot-scope="scope" class="flex">
                                <el-link type="primary" @click="addItem(scope.row)">编辑</el-link>
                                <el-link class="margin-left-sm" type="danger" @click="delItem(scope.row)">删除</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="page-box">
                    <el-pagination
                        :current-page.sync="search.page"
                        :page-size="search.limit"
                        :total="search.total"
                        background
                        class="page-all margin-top self-end"
                        layout="prev, pager, next"
                        @current-change="list">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {orgStatusOptions} from "@/utils/const";
import {findByType,confirm} from "@/utils/utils";
import {delArticle, getArticleList, setArticle} from "@/api/admin";
import LeftPage from "@/views/admin/pages/info/common/leftPage";

export default {
    name: "riskList",
    data() {
        return {
            search: {
                keyword: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            tableData: [],

            loading: false
        }
    },
    components: {LeftPage},
    computed: {
        textCenter() {
            return {
                textAlign: 'center'
            }
        },
        centerbgc() {
            return {
                textAlign: 'center',
                background: '#f7f7f7'
            }
        }
    },
    created() {
        this.$emit("setActive", {
            headActive: 5
        })
        this.list()
    },
    methods: {
        async list() {
            this.loading = true
            let _data = await getArticleList(
                this.search.keyword,
                2,
                this.search.page,
                this.search.limit
            );
            this.loading = false
            if (_data.status == 200) {
                this.tableData = _data.data.data
                this.search.total = _data.data.total
            } else {
                this.$message.error(_data.msg)
            }
        },
        refreshList() {
            this.search.page = 1
            this.list()
        },
        addItem(item) {
            this.$router.push(`/admin/noticeAdd${item ? `?id=${item.id}` : ''}`)
        },
        delItem(item) {
            confirm('删除','您确定要删除该信息吗？',()=>{
                this.delArticle(item.id)
            },'确定',true)
        },
        async delArticle(id) {
            let _data = await delArticle(id);
            if (_data.status == 200) {
                this.$message.success('删除成功')
                this.list()
            } else {
                this.$message.error(_data.msg)
            }
        },
        changeStatus(e,model, item) {
            this.setArticle(e,model, item)
        },
        async setArticle(e,model, item) {
            let _data = await setArticle(item.id,model,e)
            if (_data.status === 200) {
                this.$message.success('修改成功')
            } else {
                this.refreshList()
                this.$message.error(_data.msg)
            }
        },
    },
    watch: {},
    filters: {
        is_lock(val) {
            return findByType(orgStatusOptions, val)
        }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #f61919;
}
.orgDetail {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;
        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }
        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px
            rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }
}
.right-box {
    flex: 1;
    margin-left: 25px;
    width: 100%;
      min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
        min-height: 500px;

        .tab {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: solid 2px #e3e7f0;

            span {
                width: max-content;
                margin-left: 45px;
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: #63686e;
                margin-right: 20px;
                cursor: pointer;

                &.active {
                    color: #2791ff;
                    font-weight: bold;
                    border-radius: 2px;
                    border-bottom: solid 4px #2791ff;
                }
            }
        }


        .list {
            width: 100%;

            .btn {
                width: 60px;
                height: 26px;
                border-radius: 4px;
                font-size: 14px;
                text-align: center;
                line-height: 26px;
                margin: 0 auto;

                &.gray {
                    color: #8a8a8a;
                    background-color: #f2f2f2;
                }

                &.yellow {
                    color: #fad471;
                    background-color: #fffbdd;
                }

                &.orange {
                    color: #f58739;
                    background-color: #ffeedd;
                }

                &.red {
                    color: #f8001a;
                    background-color: #ffdddd;
                }
            }
        }

        .search-flex {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 20px 0;

            .shensu {
                min-width: 113px;
                height: 37px;
                background-image: linear-gradient(0deg,
                    #f59a23 0%,
                    #feb555 100%);
                border-radius: 4px;
                padding: 0 20px;
                text-align: center;
                line-height: 37px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                    color: #ffffff;
                }
            }

            .search-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .search-btn {
                    width: 112px;
                    height: 36px;
                    background-image: linear-gradient(0deg,
                        #2791ff 0%,
                        #81b6ff 100%);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-left: 15px;
                    cursor: pointer;

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                        color: #ffffff;
                    }

                    &.reset {
                        background-image: none;
                        background-color: #ffffff;
                        border-radius: 4px;
                        border: solid 1px #cccccc;
                        line-height: 34px;
                        color: #333333;

                        i {
                            color: #999999;
                        }
                    }
                }
            }

        }
    }
}
</style>


